import { IRequestCallback, RequestService } from '@df/api/request/request.service';
import { App } from '@df/core/app';
import { NgInject } from '@df/ng/ng-inject';
import { IAddToWishlistData, IResponseRemoveFromWishlist, Wishlist } from './wishlist';
import { Status } from '@df/core/status';
import { IProductDataV2, Product } from '@df/catalog/product/product';

export interface IWishlistItemData extends IAddToWishlistData {
    id: number;
    product: number;
    added_at: string;
}

// export interface IWishlistItemDataRequest {
//     qty: number;
//     options: any;
// }

// export interface IWishlistItemConfigurableOption {
//     code: string;
//     value: any;
// }

// export interface IWishlistItemCustomOption {
//     label: any;
//     title: string;
// }

export class WishlistItem {
    // protected _cache: {
    //     configurableOptions?: IWishlistItemConfigurableOption[];
    // } = {};

    /**
     * Request service
     */
    @NgInject(RequestService)
    protected requestService!: RequestService;

    @NgInject(App)
    protected app!: App;

    /**
     * Class constructor
     */
    constructor(
        protected wishlist: Wishlist,
        public data: IWishlistItemData
    ) {}

    /**
     * Remove item from wishlist
     */
    remove(status: Status, onSuccess?: IRequestCallback, onError?: IRequestCallback): Promise<IResponseRemoveFromWishlist> {
        return this.requestService.send<IResponseRemoveFromWishlist>(
            status,
            () => this.wishlist.remove(undefined, this.data.id),
            onSuccess,
            onError
        );
    }

    /**
     * Product getter
     */
    get product(): Product<IProductDataV2> | undefined {
        return <Product<IProductDataV2>>this.app.resources.product.getExisting(this.data.product);
    }

    /**
     * Product id getter
     */
    get productId(): number {
        return this.data.product;
    }

    /**
     * Gets bundle selection object with item options
     * (its cached in product factory)
     * @author Maurycy Ornat maurycy@tomandco.co.uk
     */
    get bundleSelection() {
        return this.product ? this.product.getBundleSelectionObject(this.data.bundle_options || {}) : undefined;
    }
}

export const wishlistItemFactory = {
    instance: WishlistItem
};
